









import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class CookieBanner extends Vue {
  @Prop() cookieBannerData: {
    button_label: string;
    text: string;
  };
  showBanner: boolean = true;
  defaultData = {
    button_label: 'Confirm',
    text: `Wir nutzen Cookies auf dieser Seite, um das Nutzererlebnis zu verbessern.<br>
           Indem Sie OK klicken, erlauben Sie uns, Cookies zu setzen und stimmen der Verarbeitung Ihrer Daten entsprechend unserer Datenschutzerklärung ein.`,
  };

  mounted() {
    this.showBanner = !Boolean(window.localStorage['agreeWithUseCookie']);
  }

  confirm() {
    window.localStorage['agreeWithUseCookie'] = true;
    this.showBanner = false;
  }
}
